<div class="modal-content">
  <div class="modal-header">
    <div class="modal-header-copy">
      <h3 id="invoice-modal-title">申请发票</h3>
      <p id="invoice-modal-subtitle">填写开票信息，电子发票将发送至邮箱</p>
    </div>
    <button class="modal-close" mat-dialog-close>×</button>
  </div>

  <!-- 表单视图 -->
  <div class="modal-body" id="invoice-form-view" [class.show]="tab === 1">
    <div mat-dialog-content style="padding: 0">
      <div class="inv-section">
        <div class="inv-section-head">
          <strong>选择开票订单</strong>
          <span>可合并开票</span>
        </div>

        <div class="inv-select-all-bar" *ngIf="total > 0">
          <label
            class="inv-select-all-label"
            [class.selected]="allSelected"
            (click)="toggleSelectAll()"
          >
            <div class="inv-check"></div>
            <span>全选 (共 {{ total }} 个订单)</span>
          </label>
        </div>

        <div class="inv-order-list" id="invoice-orders-list">
          <div
            class="inv-order-item"
            *ngFor="let item of list"
            [class.selected]="isSelected(item)"
            (click)="toggleSelect(item)"
          >
            <div class="inv-check"></div>
            <div class="inv-item-info">
              <div class="inv-item-title">
                {{ item.platform }} {{ item.product }}
              </div>
              <div class="inv-item-date">{{ item.created_time }}</div>
            </div>
            <div class="inv-item-price">¥{{ item.pay_price }}</div>
          </div>
        </div>

        <div class="inv-pagination" *ngIf="totalPages > 1">
          <button
            class="inv-page-btn"
            type="button"
            (click)="prevPage()"
            [disabled]="currentPage === 1"
          >
            上一页
          </button>
          <button
            class="inv-page-btn"
            type="button"
            *ngFor="let page of pages"
            [class.active]="page === currentPage"
            (click)="goToPage(page)"
          >
            {{ page }}
          </button>
          <button
            class="inv-page-btn"
            type="button"
            (click)="nextPage()"
            [disabled]="currentPage === totalPages"
          >
            下一页
          </button>
        </div>
      </div>

      <div class="inv-section">
        <div class="inv-section-head">
          <strong>开票信息</strong>
          <span>请准确填写</span>
        </div>
        <div class="inv-type-switch">
          <button
            class="inv-type-btn"
            id="inv-type-personal"
            type="button"
            [class.active]="type === 'personal'"
            (click)="switchType('personal')"
          >
            个人/非企业
          </button>
          <button
            class="inv-type-btn"
            id="inv-type-enterprise"
            type="button"
            [class.active]="type === 'enterprise'"
            (click)="switchType('enterprise')"
          >
            企业单位
          </button>
        </div>
        <form [formGroup]="formGroup">
          <div class="inv-field">
            <label class="inv-label" for="inv-title"
              >发票抬头 <span class="inv-required">*</span></label
            >
            <input
              type="text"
              class="inv-input"
              id="inv-title"
              formControlName="title"
              placeholder="请输入发票抬头"
              autocomplete="off"
            />
          </div>
          <div
            class="inv-field"
            id="inv-tax-field"
            [class.hidden]="type === 'personal'"
          >
            <label class="inv-label" for="inv-tax"
              >纳税人识别号 <span class="inv-required">*</span></label
            >
            <input
              type="text"
              class="inv-input"
              id="inv-tax"
              placeholder="请输入纳税人识别号"
              formControlName="tax"
              autocomplete="off"
            />
          </div>
          <div class="inv-field">
            <label class="inv-label" for="inv-email"
              >接收邮箱 <span class="inv-required">*</span></label
            >
            <input
              type="email"
              class="inv-input"
              id="inv-email"
              placeholder="请输入能正常接收发票的邮箱"
              formControlName="email"
              autocomplete="email"
            />
          </div>
        </form>

        <div class="inv-amount-card">
          <span>开票金额</span>
          <strong
            >¥<span id="inv-total-display">{{
              totalAmount.toFixed(2)
            }}</span></strong
          >
        </div>
      </div>

      <ul class="inv-rules">
        <li>类目统一为：*生活生产服务*其他咨询服务</li>
        <li>发票遵循实付实开原则，不支持自定义增加备注。</li>
        <li>提交申请后预计 7 天内开具，并发送至您填写的邮箱。</li>
      </ul>
    </div>
    <button
      class="inv-submit-btn"
      id="inv-submit-btn"
      type="button"
      (click)="submitInvoice()"
      [disabled]="formGroup.invalid || selectedList.length === 0"
    >
      提交开票
    </button>
  </div>

  <!-- 二次确认视图 -->
  <div
    class="inv-confirm-view"
    id="invoice-confirm-view"
    [class.show]="tab === 2"
    mat-dialog-content
  >
    <div class="inv-confirm-tip">
      <i>!</i
      ><span
        >请再次确认以下信息。发票提交后将按此信息开具并发送，尤其请核对抬头、税号、金额和邮箱。</span
      >
    </div>
    <div class="inv-confirm-list">
      <div class="inv-confirm-row">
        <span>发票类型</span
        ><strong id="confirm-type">{{
          type === "personal" ? "个人/非企业" : "企业单位"
        }}</strong>
      </div>
      <div class="inv-confirm-row">
        <span>发票抬头</span
        ><strong id="confirm-title">{{ formGroup.value.title }}</strong>
      </div>
      <div
        class="inv-confirm-row"
        id="confirm-tax-row"
        [class.hidden]="type !== 'enterprise'"
      >
        <span>纳税人识别号</span
        ><strong id="confirm-tax">{{ formGroup.value.tax }}</strong>
      </div>
      <div class="inv-confirm-row amount">
        <span>开票金额</span
        ><strong id="confirm-amount">{{ totalAmount.toFixed(2) }}</strong>
      </div>
      <div class="inv-confirm-row">
        <span>接收邮箱</span
        ><strong id="confirm-email">{{ formGroup.value.email }}</strong>
      </div>
    </div>
    <div class="inv-actions">
      <button
        class="inv-secondary-btn"
        type="button"
        (click)="tab = 1"
        [disabled]="loading"
      >
        返回修改
      </button>
      <button
        class="inv-submit-btn"
        type="button"
        (click)="submit()"
        [disabled]="loading"
      >
        确认提交
      </button>
    </div>
  </div>

  <!-- 提交成功后的等待开票视图 -->
  <div
    class="inv-success-view"
    id="invoice-success-view"
    [class.show]="tab === 3"
    mat-dialog-content
  >
    <div class="inv-pending-icon">
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M12 7v5l3 2"></path>
      </svg>
    </div>
    <h4>开票申请已提交</h4>
    <p>发票不会立即生成，预计将在提交后的 7 天内开具。</p>
    <p>开具完成后，电子发票会自动发送至以下邮箱：</p>
    <div class="inv-success-email" id="inv-success-email">
      {{ formGroup.value.email }}
    </div>
    <button
      class="primary-btn"
      style="width: 100%; border-radius: 10px"
      (click)="close()"
    >
      知道了
    </button>
  </div>
</div>
